export default "__VITE_ASSET__D37k8sgh__"